module.exports = __webpack_public_path__ + "static/media/bearded-bastard.76bfcceb.png";